import { useState } from 'react'

// Touch devices fire mouseenter without a matching mouseleave, so hover-driven
// JS state (tooltips, reveal-on-hover) sticks open. Gate that state on this.
export function useCanHover(): boolean {
  return useState(() => window.matchMedia('(hover: hover)').matches)[0]
}
